import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import trialApi, { TrialData } from '../../apis/trial.api'
import trialService from '../../services/trial.service'
import { ActionName } from '../../components/Actions'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import PageHeading from '../../components/PageHeading'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../../components/TableHorizontal'
import Card from '../../components/Card'

interface Props {}

interface State {
  trials: TableHorizontalData<TrialData>[]
}

export default class Trials extends Component<Props, State> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Type"), path: 'typeText' },
    { heading: i18n("Organization"), path: 'organization' },
    { heading: i18n("Name"), path: 'name' },
    { heading: i18n("Role"), path: 'role' },
    { heading: i18n("Username"), path: 'username' },
    { heading: i18n("Email"), path: 'email' },
    { heading: i18n("Phone"), path: 'phone' },
    { heading: i18n("Timezone"), path: 'timezone.name' },
    { heading: i18n("Address"), path: 'address.fullAddress', breakable: true },
    { heading: i18n("Status"), path: 'status', isBadge: true },
    { heading: i18n("Expire at"), path: 'site.endAt', date: true },
    { heading: i18n("Created at"), path: 'createdAt', date: true },
    { heading: i18n("Actions") }
  ]

  constructor (props: Props) {
    super(props)
    this.state = {
      trials: []
    }
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'accept') {
      trialApi.approve(id, response => {
        if (!response || !response.approved) return
        this.setState(state => {
          const trials = trialService.updateStatus(state.trials, id, 'approved')
          return { trials }
        })
      })
    } else if (action === 'reject') {
      trialApi.reject(id, response => {
        if (!response || !response.rejected) return
        this.setState(state => {
          const trials = trialService.updateStatus(state.trials, id, 'rejected')
          return { trials }
        })
      })
    } else if (action === 'onboard') {
      trialApi.onboard(id, response => {
        if (!response || !response.onboarded) return
        this.setState(state => {
          const trials = trialService.updateStatus(state.trials, id, 'onboarded')
          return { trials }
        })
      })
    } else if (action === 'close') {
      trialApi.close(id, response => {
        if (!response || !response.closed) return
        this.setState(state => {
          const trials = trialService.updateStatus(state.trials, id, 'closed')
          return { trials }
        })
      })
    }
  }

  listTrials () {
    trialApi.list(trials => {
      if (!trials) return
      const trialsData = trialService.tableHorizontalData(trials)
      this.setState({ trials: trialsData })
    })
  }

  componentDidMount () {
    this.listTrials()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <PageHeading text={i18n("Free accounts")} />
            <TableHorizontal
              headers={this.tableHeaders}
              data={this.state.trials}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}
